import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserEffects } from './effects/user.effect';
import { UserHandler } from './handler/user.handler';
import { UserReducer } from './reducer/user.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(UserReducer.userFeatureKey, UserReducer.reducer),
    EffectsModule.forFeature([UserEffects]),
  ],
  providers: [UserHandler],
})
export class UserReduxModule {}
